// Generated by CoffeeScript 1.11.1
(function() {
  var ResourceSection, _,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  _ = require('lodash');

  module.exports = ResourceSection = (function() {
    var RESOURCES;

    function ResourceSection() {}

    RESOURCES = [require('./resources/layer_comps'), require('./resources/layer_links'), require('./resources/resolution_info'), require('./resources/global_light_angle'), require('./resources/global_light_altitude'), require('./resources/origin_path_info'), require('./resources/path_selection'), require('./resources/path'), require('./resources/thumbnail')];

    ResourceSection.factory = function(resource) {
      var Section, i, j, len, ref, results;
      for (i = 0, len = RESOURCES.length; i < len; i++) {
        Section = RESOURCES[i];
        if (Section.prototype.id === resource.id) {
          return _.tap(new Section(resource), function(s) {
            return s.parse();
          });
        }
        if ((ref = resource.id, indexOf.call((function() {
          results = [];
          for (j = 2000; j < 2998; j++){ results.push(j); }
          return results;
        }).apply(this), ref) >= 0) && Section.prototype.id === 2000) {
          return _.tap(new Section(resource), function(s) {
            return s.parse();
          });
        }
        continue;
      }
      return null;
    };

    return ResourceSection;

  })();

}).call(this);
